export const services = {
  headers: {
    requestedService: "Servizio richiesto",
  },
  actions: {
    discardRequest: "Scarta richiesta",
  },
  storeInactiveTitle: "Lo store dei servizi non è attivo",
  storeInactiveDesc1:
    "Per ricevere richieste di esperienze e servizi aggiuntivi, devi attivare il tuo store.",
  storeInactiveDesc2:
    "Una volta attivato, i tuoi ospiti potranno richiedere servizi direttamente su WhatsApp.",
  activateStoreBtn: "Attiva lo store dei servizi",

  noServicesDesc1:
    "Attiva le Esperienze configurando i tuoi servizi aggiuntivi: colazione, tour, transfer o qualsiasi cosa tu offra.",
  noServicesDesc2:
    "I tuoi ospiti li vedranno subito dopo il check-in, direttamente su WhatsApp.",
  addFirstServiceBtn: "Aggiungi la mia prima esperienza o servizio",
};
